import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Users (UserDto) with access to a job. */
export function useJobUsers(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.jobs.users(jobId ?? -1),
    queryFn: ({ signal }) =>
      jobApiClient.getJobUsers(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 60_000,
    meta: { errorContext: 'job users' },
  });
}
